import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "zh",
    debug: true,
    resources: {
      en: {
        translation: {
          index: "Home",
          data: {
            title: "Data",
            concentration: "Sea ice concentration",
            thickness: "Sea ice thickness",
            temperature: "Temperature",
            wind: "Wind",
          },
          analysis: {
            title: "Decision",
            lane: "Distribution of optimal route",
            remote: "Sea ice monitoring",
            navigator: "Navigation",
            shippingRoutePlanning: "Calculation of optimal route",
          },
          tool: {
            title: "Tools",
          },
          switcher: {
            timeline: "Select time",
            indicator: "Information panel",
            risk: "RIO",
            buffer: "Navigation area",
            ice: "Sea ice along the route",
            weather: "Temperature prediction",
            flow: "Introduction to calculation process",
            routeDate: "Navigation window",
            step: "Step",
            center: "Select center",
            order: "Orders",
            archStep: "Thought",
            form: "Setting",
          },
          timeline: {
            history: "History",
            prediction: "Prediction",
            irregular: "Realtime",
            year: "Select year",
            month: "Select month",
            day: "Select day",
            co2: "Select co2",
            ship: "Select ship",
            ship1: "Arc4 ice-strengthened ship",
            ship2: "Non-ice-class ship",
          },
          indicator: {
            layer: "Select layer",
            ds1: "Data source1",
            ds2: "Data source2",
            startPoint: "Start point",
            endPoint: "End point",
            zone: "Zone",
          },
          temperature: {
            empty: "No data",
            default: "Select layer",
          },
          order: {
            date: "Date",
            status: "Status",
            username: "Username",
            email: "Email",
            points: "Points",
            ftp: "Ftp",
            result: "Username and password are sent by email",
            fullfile: "The task is in progress, please try later.",
            success: "The task is submited successfully.",
            lng: "Lon",
            lat: "Lat",
            lngMessage: "Longitude is required.",
            latMessage: "Latitude is required.",
            lngInput: "Please typed longitude.",
            latInput: "Please typed latitude",
            resultRange: "Result",
            loading: "Submitting",
            submit: "Submit",
            cancel: "Cancel",
            map: "Select by map",
            clean: "Clean",
            empty: "No data",
          },
          step: {
            title1: "Calculated by region",
            desc1:
              "Enter or select the coordinates of the center point of the area",
            title2: "Set the resolution of calculation results",
            desc2:
              "Drag the button to select the resolution of the output image",
            title3: "Start online calculation",
            desc3: 'Click "submit" button to start online calculation',
            title4: "Distribution of results",
            desc4:
              "The calculation results are automatically distributed by mail",
          },
          legend: {
            concentration: "Concentration",
            thickness: "Thickness",
            temperature: "Temperature",
            wind: "Wind",
            route: "RIO",
            remote: "Concentration",
          },
          ice: {
            start: "Start",
            end: "End",
            concentration: "Concentration",
            thickness: "Thickness",
            nodata: "No data",
          },
        },
      },
      zh: {
        translation: {
          index: "返回首页",
          data: {
            title: "数据浏览",
            concentration: "海冰密集度",
            thickness: "海冰厚度",
            temperature: "温度",
            wind: "风速",
          },
          analysis: {
            title: "分析决策",
            lane: "最优航线时空分布",
            remote: "海冰遥感监测",
            navigator: "航道导航",
            shippingRoutePlanning: "最优航线实时规划",
          },
          tool: {
            title: "工具",
          },
          switcher: {
            timeline: "时间选择",
            indicator: "信息面板",
            risk: "风险值RIO",
            buffer: "通航区域",
            ice: "沿途冰情",
            weather: "温度预测",
            flow: "通航风险计算流程",
            routeDate: "通航窗口",
            step: "使用步骤",
            center: "选取计算中心点",
            order: "数据处理订单",
            archStep: "计算思路",
            form: "导航参数",
          },
          timeline: {
            history: "历史航线分布",
            prediction: "未来航线分布",
            irregular: "近实时",
            year: "选择年份",
            month: "选择月份",
            day: "选择天",
            co2: "选择Co2排放场景",
            ship: "选择船舶类型",
            ship1: "PC6破冰船",
            ship2: "普通商船",
          },
          indicator: {
            layer: "请选择图层",
            ds1: "数据源1",
            ds2: "数据源2",
            startPoint: "起点",
            endPoint: "终点",
            zone: "途经海域",
          },
          temperature: {
            empty: "暂无数据",
            default: "请点击航道，查看温度信息。",
          },
          order: {
            date: "时间",
            status: "状态",
            username: "用户名",
            email: "电子邮箱",
            points: "中心点",
            ftp: "Ftp",
            result: "用户名和密码已经通过邮件发送",
            fullfile: "计算任务进行中，请稍后再试!",
            success: "计算任务提交成功，计算结果会以邮件形式下发!",
            lng: "经度",
            lat: "纬度",
            lngMessage: "经度不能为空",
            latMessage: "纬度不能为空",
            lngInput: "请输入经度",
            latInput: "请输入纬度",
            resultRange: "结果范围",
            loading: "提交中",
            submit: "提交",
            cancel: "取消选取",
            map: "在地图中选取",
            clean: "清空",
            empty: "暂无数据",
          },
          step: {
            title1: "选择区域",
            desc1: "输入或选择计算中心点",
            title2: "按区域计算",
            desc2: "根据中心点按区域计算监测内容",
            title3: "开始在线计算",
            desc3: "点击“提交”按钮开始在线计算",
            title4: "结果分发",
            desc4: "计算结果通过邮件分发",
          },
          legend: {
            concentration: "海冰密集度",
            thickness: "海冰厚度",
            temperature: "温度",
            wind: "风速",
            route: "风险值RIO",
            remote: "海冰密集度",
          },
          ice: {
            start: "起点",
            end: "终点",
            concentration: "密集度",
            thickness: "厚度",
            nodata: "无数据",
          },
        },
      },
    },
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
  });

export default i18n;
